import React, { FunctionComponent } from 'react'
import Skeleton, { ISkeletonProps } from 'react-native-reanimated-skeleton'

import { useTheme } from 'styled-components/native'

import { ThemeType } from '../../utils'

export interface BaseSkeletonProps extends Omit<ISkeletonProps, 'boneColor' | 'highlightColor' | 'isLoading'> {
  isLoading?: boolean
}

export const BaseSkeleton: FunctionComponent<BaseSkeletonProps> = ({
  isLoading = true,
  animationDirection = 'horizontalRight',
  children,
  ...restOfProps
}) => {
  const { colors } = useTheme() as ThemeType
  return (
    <Skeleton
      animationDirection={animationDirection}
      boneColor={colors.skeletonBoneColor}
      highlightColor={colors.skeletonHighlightColor}
      isLoading={isLoading}
      {...restOfProps}
    >
      {children}
    </Skeleton>
  )
}
